import { SimpleTable } from "./SimpleTable";
import { SimpleTableNullDate } from "./SimpleTableNullDate";

export * from "./interface";
export { SimpleTable, SimpleTableNullDate };
